import { Typography, Button, Box } from "@mui/material";
import styled from "styled-components";
import Container from "../presentation/Container";
import { Link } from "react-router-dom";
import SEO from "../global/SEO";

const PageNotFound = () => (
  <>
    <SEO 
      title="Page Not Found | LiveAssignment.com"
      description="The page you're looking for doesn't exist. Return to our homepage for assignment help services."
      keywords="page not found, 404 error, assignment help homepage"
      h1Heading="Page Not Found"
      canonicalUrl="https://liveassignment.com/404"
    />
    <Wrapper>
      <Container>
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography variant="h1" component="h1" gutterBottom>
            404
          </Typography>
          <Typography variant="h4" gutterBottom>
            Page Not Found
          </Typography>
          <Typography variant="body1" paragraph sx={{ mb: 4 }}>
            The page you're looking for doesn't exist. Return to our homepage for assignment help services.
          </Typography>
          <Button 
            component={Link} 
            to="/" 
            variant="contained" 
            color="primary"
            size="large"
          >
            Go to Homepage
          </Button>
        </Box>
      </Container>
    </Wrapper>
  </>
);

export default PageNotFound;

const Wrapper = styled.div`
  padding: 70px 0;
  position: relative;
  min-height: 40vh;

  @media (max-width: 992px) {
    padding: 40px 0;
  }
`;
